import React from 'react';
import PricingHero from '../components/PricingHero/PricingHero';
import PricingCards from '../components/PricingCards/PricingCards';
import './SubscriptionPackages.css';

const SubscriptionPackages = () => {
  return (
    <div className="subscription-packages">
      <PricingHero />
      <PricingCards />
    </div>
  );
};

export default SubscriptionPackages; 